import React, {useState, useEffect, useRef} from 'react';
import {NavLink, useParams} from "react-router-dom";
import '../../assets/css/tournament-details.css';
import Loader from "../includes/Loader";
import {requestPostHTTP} from "../helpers/helper";
import {isLogin} from "../auth/AuthController";
import {useSelector} from "react-redux";
import rewardsImg from "../../assets/images/icons/rewards.png";
import videoIcon from "../../assets/images/icons/video.png";
import Modal from "../pusher/Modal";
import VideoModal from "../modals/VideoModal";
import {handleDiscordLogin} from "../auth/DiscordAuth"

const TournamentDetails = () => {
    const [loading, setLoading] = useState(true);
    const [tournamentDetail, setTournamentDetail] = useState(true);
    const {tournamentId} = useParams();
    const modal = useSelector((state) => state.openSubscribedModal);
    const [tournamentCheckIn, setTournamentCheckIn] = useState([]);
    const showSuccessModal = useRef(null);
    const pubgId = useRef(null);
    const pubgNick = useRef(null);
    const [pubgValidation, setPubgValidation] = useState(false);
    const [notFoundTournament, setNotFoundTournament] = useState(false);
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);


    useEffect(() => {
        async function fetchTournamentDetails() {
            try {
                const tournament = await requestPostHTTP('/v1/tournament/view', {id: tournamentId});
                if (tournament.data.length > 0) {
                    setTournamentDetail(tournament.data[0]);
                } else {
                    setNotFoundTournament(true);
                }
            } catch (error) {
                console.error('Error fetching tournament data:', error);
                setNotFoundTournament(true);
            } finally {
                setLoading(false);
            }
        }

        fetchTournamentDetails();
    }, []);

    function openVideoModal(){
        setIsVideoModalOpen(true);
    }

    /**
     *
     * @param tourn_id
     */
    function funTournamentCheckIn(event, tourn_id) {
        if (!isLogin()) {
            modal.subscribedModalRef.current.click();
        }
        try {
            var params = {id: tourn_id};
            setPubgValidation(false);
            if(tournamentDetail.tourn_name === 'Freefire Rampage' || tournamentDetail.tourn_name === 'PUBG Mobile' || tournamentDetail.tourn_name === 'Call of Duty'){
                if (!pubgId.current.value.trim() || !pubgNick.current.value.trim()) {
                    setPubgValidation(true);
                    return;
                }
                params = {id: tourn_id, pubg_id:pubgId.current.value, pubg_nick:pubgNick.current.value};
            }
            requestPostHTTP('/v1/tournament/entry/checkin', params).then(response => {
                if (response && response.data.already_submited === true) { // already exist
                    setTournamentCheckIn('You have already Submitted.');
                    showSuccessModal.current.click();
                } else if (response && response.data.length > 0) {
                    setTournamentCheckIn('Congratulations! You\'ve successfully entered in the tournament. Please wait for the upcoming message with further instructions on how to join. Thank you for your participation and patience.');
                    showSuccessModal.current.click();
                }
            });
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            {loading ? (
                <Loader/>
            ) : (
                <>
                    <div className="container-fluid px-3">
                        <div className="row">
                            <div className="col-md-12">
                                <img className="img-fluid tournament-detail-banner-img" src={tournamentDetail.banner}
                                     alt="banner-tournament"/>
                            </div>

                            {/*<div className="play-now-card-slider-btn">
                                <NavLink className="play-btn w-160"
                                         onClick={handleDiscordLogin}>
                                    Login with Discord
                                </NavLink>
                            </div>*/}

                            <div className="mt-5">
                                <div className="col-md-12">
                                    {tournamentDetail.tourn_name === 'Call of Duty' && (
                                        <p className="detail mb-4 video-link-wrapper">
                                            <a href="javaScript:void(0)" className="watch-video-link"
                                               onClick={() => openVideoModal()}><img className="video-icon"
                                                                                     src={videoIcon} alt=""/>Watch Video</a>
                                        </p>
                                    )}
                                    <p className="detail mb-4">
                                        <span>Tournament Name: </span>
                                        {tournamentDetail.tourn_name}
                                    </p>
                                    <p className="detail mb-4">
                                        <span>Prize: </span>
                                        {tournamentDetail.prize}
                                    </p>
                                    <p className="detail mb-4">
                                        <span>Platform: </span>
                                        {tournamentDetail.platform}
                                    </p>
                                    <p className="detail mb-4">
                                        <span>Starting Time: </span>
                                        {tournamentDetail.timeStart}
                                    </p>
                                    <p className="detail mb-4">
                                        <span>Ending Time: </span>
                                        {tournamentDetail.timeEnd}
                                    </p>

                                    {(tournamentDetail.tourn_name === 'Freefire Rampage' || tournamentDetail.tourn_name === 'PUBG Mobile' || tournamentDetail.tourn_name === 'Call of Duty') && (
                                        <div className="pubg_fields_wrapper">
                                            {/* Enter fields for PUBG*/}
                                            <div className="col-4 col-sm-6 col-md-4 col-lg-4">
                                                <input
                                                    type="text"
                                                    name='pubgId'
                                                    placeholder="Enter Your UID"
                                                    className="bio-detail-textarea"
                                                    ref={pubgId}
                                                />
                                            </div>
                                            <div className="col-4 col-sm-6 col-md-4 col-lg-4">
                                                <input
                                                    type="text"
                                                    name='pubgNick'
                                                    placeholder="Enter Your NICK"
                                                    className="bio-detail-textarea"
                                                    ref={pubgNick}
                                                />
                                            </div>
                                            <div className="col-4 col-sm-6 col-md-4 col-lg-4">
                                                {pubgValidation && (<p className="text-red mt-1">Entering UID and NICK is mandatory for registering. Please enter correct ID and NICK to claim your prize.</p>)}
                                            </div>
                                        </div>
                                        )}
                                    <div className="play-now-card-slider-btn">
                                        <NavLink className="play-btn"
                                                 onClick={(event) => funTournamentCheckIn(event, tournamentId)}>
                                            Register
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {isVideoModalOpen && (
                        <VideoModal videoUrl={window.location.origin+'/videos/cod.mp4'} onClose={()=>setIsVideoModalOpen(false)} />
                    )}

                    {/*Model*/}
                    <div className="modal fade subscribe-modal" id="showSuccess" tabIndex="-1"
                         aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog subscribe-modal-dialog">
                            <div className="modal-content subscribe-modal-content">
                                <div className="modal-body subscribe-modal-body">
                                    <div className="subscribe-modal-body-back-img notification-back-img">
                                        <img className="rewards-modal-icon" src={rewardsImg} alt="rewards-success"/>
                                    </div>
                                    <h6 className="subscribe-info-heading-modal">Congratulations</h6>
                                    <p className="subscribe-heading-modal">{tournamentCheckIn}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button style={{display: 'none'}} ref={showSuccessModal} data-bs-toggle="modal"
                            data-bs-target="#showSuccess">modal box
                    </button>
                </>
            )}
        </>
    );
}

export default TournamentDetails;
